<div class="flex flex-col">
  <!-- <app-sidenav-header [title]="title"></app-sidenav-header> -->
  <div class="dbbackup pr-10">
    <form [formGroup]="dbForm" class="p-8">
      <div class="flex flex-row mb-6 justify-between">
      <div class="flex flex-col">
        <div class="mat-headline-5 mb-0">{{'INSTANCE_DETAILS.DATABASE_BACKUP.TITLE' | transloco}}</div>
        <div class="mat-body fw-400 pt-0">{{instanceName? instanceName : '-'}}</div>
      </div>
      <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" (click)="sidenavService.closeRightSidenav()"></mat-icon>
      </div>
      <mat-divider class="neutral-2"></mat-divider>

      <div class="flex justify-between">
          <div>
              <div class="mat-body-2 fw-700 pt-24">{{'INSTANCE_DETAILS.DATABASE_BACKUP.INSTANCE_NAME' | transloco}}</div>
              <div class="mat-body fw-400">{{instanceName? instanceName : '-'}}</div>
          </div>
      </div>
      <div class="flex justify-between">
          <div>
              <div class="mat-body-2 fw-700 pt-24">{{'INSTANCE_DETAILS.DATABASE_BACKUP.DATABASE' | transloco}}</div>
              <div class="mat-body fw-400 ellipsis" 
              matTooltipClass="above" 
              matTooltipPosition="above" 
              [matTooltip]="databases?.backupType === 'archive' ? databases?.to?.fileName : databases?.backupType === 'snapshot' ? databases?.to?.databaseName : '-'"
             >{{databases?.backupType === 'archive' && databases?.to?.fileName ? databases?.to?.fileName : databases?.backupType === 'snapshot' && databases?.to?.databaseName ? databases?.to?.databaseName : '-'}}</div>
          </div>
        
      </div>
      <div class="flex justify-between">
          <div>
              <div class="mat-body-2 fw-700 pt-24">{{'INSTANCE_DETAILS.DATABASE_BACKUP.CREATED_DATE' | transloco}}</div>
              <div class="mat-body fw-400">{{databases?.createdAt ? (databases?.createdAt | date: 'dd MMM yyyy') : '-'}}</div>
          </div>        
      </div>
      <div class="flex justify-between">
        <div>
            <div class="mat-body-2 fw-700 pt-24">{{'INSTANCE_DETAILS.DATABASE_BACKUP.RETENTION' | transloco}}</div>
            <div class="mat-body fw-400">{{databases?.expirationDate  | date: 'dd MMM yyyy'}}  ({{databases?.expiryDays}} days)</div>
        </div>        
    </div>
    <div class="flex justify-between">
      <div>
          <div class="mat-body-2 fw-700 pt-24">{{'INSTANCE_DETAILS.DATABASE_BACKUP.CREATED_BY' | transloco}}</div>
          <div class="mat-body fw-400">{{databases?.createdBy? databases?.createdBy : '-'}}</div>
      </div>        
  </div>
  <div class="flex justify-between">
    <div>
        <div class="mat-body-2 fw-700 pt-24 pb-1">{{'INSTANCE_DETAILS.DATABASE_BACKUP.STATUS' | transloco}}</div>
        <div class="flex items-center status pl-8 pr-8 pt-2 pb-2" [ngClass]="databases?.status">
          <span>
            <mat-icon *ngIf="databases?.status === 'completed'" svgIcon="check_circle" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'failed'" svgIcon="close" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'expired'" svgIcon="error" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'inprogress'" svgIcon="change_circle" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'deleted'" svgIcon="check_circle" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'deleting'" svgIcon="change_circle" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
            <mat-icon *ngIf="databases?.status === 'delete_failed'" svgIcon="close" class="icon-md p-2 mr-4" [ngClass]="databases?.status"></mat-icon>
          </span>
          <span>
            {{databases?.status === 'delete_failed'? ('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_FAILED' | transloco) : databases?.status | titlecase}}
          </span>
        </div>
       
    </div>        
</div>
    </form>
  </div>
  <span class="flex-auto"></span>
  <mat-divider class="neutral-2 mb-20"></mat-divider>

  <div class="pt-4 pb-16">
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
      <button class="accent" type="button" (click)="deleteConfirm()">{{'BUTTONS.SUBMIT' | transloco}}</button>
    </div>
  </div>
</div>
